import MiNotice from './notice';
import MiNoticeTab from './tab';
import MiNoticeItem from './item';
MiNotice.Tab = MiNoticeTab;
MiNotice.Item = MiNoticeItem;
MiNotice.install = (app) => {
    app.component(MiNotice.name, MiNotice);
    app.component(MiNoticeTab.name, MiNoticeTab);
    app.component(MiNoticeItem.name, MiNoticeItem);
    return app;
};
export default MiNotice;
